const RupMain = () => import("../views/rup/RupMain.vue");
const RupHome = () => import("../views/rup/RupHome.vue");
const RupKegiatan = () => import("../views/rup/RupKegiatan.vue");
const RupKegiatanView = () => import("../views/rup/RupKegiatanView.vue");
const RupKegiatanSup = () => import("../views/rup/RupKegiatanSup.vue");
const RupKegiatanPPK = () => import("../views/rup/RupKegiatanPPK.vue");
const RupKegiatanULP = () => import("../views/rup/RupKegiatanULP.vue");
const RupKegiatanPA = () => import("../views/rup/RupKegiatanPA.vue");
const RupPaketPenyedia = () => import("../views/rup/RupPaketPenyedia.vue");
const RupPaketPenyediaMan = () => import("../views/rup/RupPaketPenyediaMan.vue");
const RupPaketPenyediaPPK = () => import("../views/rup/RupPaketPenyediaPPK.vue");
const RupPaketPenyediaULP = () => import("../views/rup/RupPaketPenyediaULP.vue");
const RupPaketPenyediaPA = () => import("../views/rup/RupPaketPenyediaPA.vue");
const LearnList = () => import("../views/rup/LearnList.vue")
 
const rup = [
  {
    path: '/rup',
    component: RupMain,
    meta: { auth: true, rup: true },    
    children:
    [
        {
            path: "home",
            component: RupHome
        },
        {
            path: "kegiatan",
            component: RupKegiatan
        },
        {
          path: "kegiatan/view",
          component: RupKegiatanView
      },
        {
          path: "kegiatan/sup",
          component: RupKegiatanSup
        },
        {
          path: "kegiatan/ppk",
          component: RupKegiatanPPK
        },
        {
          path: "kegiatan/ulp",
          component: RupKegiatanULP
        },
        {
          path: "kegiatan/pa",
          component: RupKegiatanPA
        },
        {
            path: "paket/penyedia",
            component: RupPaketPenyedia
        },
        {
          path: "paket/penyedia/man",
          component: RupPaketPenyediaMan
        },
        {
          path: "paket/penyedia/ppk",
          component: RupPaketPenyediaPPK
        },
        {
          path: "paket/penyedia/ulp",
          component: RupPaketPenyediaULP
        },
        {
          path: "paket/penyedia/pa",
          component: RupPaketPenyediaPA
        },
        {
          path: "paket/learn",
          component: LearnList
        }
    ]
  },
]

export default rup